export default "__VITE_ASSET__CgyFKTEd__"